import { onSnapshot, orderBy, query, where } from "firebase/firestore";
import React, { useState, useEffect, useContext } from "react";
import { operativesRef } from "../firebase";
import { AuthContext } from "./AuthProvider";

const OperativesContext = React.createContext([]);

const OperativesProvider = ({ children }) => {
  const { userData } = useContext(AuthContext);
  const [operatives, setOperatives] = useState([]);

  useEffect(() => {
    if (!userData.uid) {
      return;
    }

    let q = query(
      operativesRef,
      orderBy("name", "desc"),
      where("createdBy", "in", userData.associatedAccounts)
    );
    const unSubFromOperatives = onSnapshot(q, (querySnapshot) => {
      const dbOperatives = [];
      querySnapshot.forEach((operative) => {
        dbOperatives.push(operative.data());
      });
      setOperatives(dbOperatives);
    });

    return () => {
      // console.log("unsubbing from operatives");
      unSubFromOperatives();
    };
  }, [userData.associatedAccounts, userData.uid]);

  return (
    <OperativesContext.Provider value={operatives}>
      {children}
    </OperativesContext.Provider>
  );
};

export { OperativesProvider, OperativesContext };
